export default __webpack_public_path__ + "static/media/tingkatkan_portofolio.c3d7af6b.svg";